import { MainApi } from "./MainApi";
import { TestResultSearchCondition } from "../types/dataSearch";

export class DataSearchApi {
  static baseUrl = `${MainApi.urlPrefix}/data-search`;

  // 조회가능 데이터셋 메타데이터 목록
  static getDatasets = () => () => MainApi.api.get(`${DataSearchApi.baseUrl}/datasets`);

  // 검사결과 목록 조회 (필터빌더)
  static getTestResultList = (condition: TestResultSearchCondition) => () =>
    MainApi.api.get(`${DataSearchApi.baseUrl}/test-result${MainApi.toParamStringFromObject(condition)}`);

  // 검사결과 엑셀 다운로드
  static downloadTestResult = (condition: TestResultSearchCondition) => () =>
    MainApi.api.get(`${DataSearchApi.baseUrl}/test-result/download${MainApi.toParamStringFromObject(condition)}`, {
      responseType: "blob",
    });

  // 검사결과 문항별 목록 조회 (필터빌더)
  static getTestResultItemList = (condition: TestResultSearchCondition) => () =>
    MainApi.api.get(`${DataSearchApi.baseUrl}/test-result-item${MainApi.toParamStringFromObject(condition)}`);

  // 검사결과 문항별 엑셀 다운로드
  static downloadTestResultItem = (condition: TestResultSearchCondition) => () =>
    MainApi.api.get(`${DataSearchApi.baseUrl}/test-result-item/download${MainApi.toParamStringFromObject(condition)}`, {
      responseType: "blob",
    });
}
